import Stack from "@mui/material/Stack";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import React from "react";

export default function TextFieldLabel({ label, required = false }) {
  const theme = useTheme();
  return (
    <Stack direction="row">
      <Typography>{label}</Typography>
      {required && (
        <Typography style={{ color: theme.palette.required.main }}>
          *
        </Typography>
      )}
    </Stack>
  );
}
